let lastId = 0;

const newUnique = (prefix = 'id') => {
    lastId++;
    return `${prefix}${lastId}`;
};

export default newUnique;
